<div>

  <div class="modal-header" style="border-bottom: none;" *ngIf="showAdminComponents">
    <ul class="nav nav-tabs modal-title" id="myTab0" role="tablist" (click)="onButtonGroupClick($event)">

      <button class="nav-link active view-container" id="" data-mdb-toggle="tab" data-mdb-target="#home0" type="button"
        role="tab" aria-controls="home">
        View
      </button>

      <button class="nav-link add-container" id="" data-mdb-toggle="tab" data-mdb-target="#profile0" type="button"
        role="tab" aria-controls="profile">
        Add
      </button>
    </ul>
  </div>
  <div class="tab-content" id="myTabContent0" *ngIf="showAdminComponents">
    <div class="tab-pane fade show active view-container-content" id="" role="tabpanel"
      aria-labelledby="view-container">
      <app-configurations-page></app-configurations-page>
    </div>

    <div class="tab-pane fade add-container-content tab-content-v2" id="" role="tabpanel"
      aria-labelledby="add-container">
      <app-add-institution-main></app-add-institution-main>
    </div>
  </div>

  <div class="tab-content" id="myTabContent1" *ngIf="showBrokerComponents">
    <div class="tab-pane fade show active view-container-content" id="" role="tabpanel"
      aria-labelledby="view-container">
      <app-configurations-page></app-configurations-page>
    </div>

  </div>

  <div class="tab-content" id="myTabContent2" *ngIf="showBrokerAdminComponents">
    <div class="tab-pane fade show active view-container-content" id="" role="tabpanel"
      aria-labelledby="view-container">
      <app-configurations-page-component2></app-configurations-page-component2>
    </div>
  </div>

</div>